import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "cross",
  "use": "cross-usage",
  "viewBox": "0 0 12.42 12.42",
  "content": "<symbol viewBox=\"0 0 12.42 12.42\" id=\"cross\"><path d=\"M7.63 6.21L12.42 11 11 12.42 6.21 7.63l-4.79 4.79L0 11l4.79-4.79L0 1.42 1.42 0l4.79 4.79L11 0l1.42 1.42-4.79 4.79z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./application/components/dumb/icon/src/cross.svg
// module id = 158
// module chunks = 0